// Polyfill only stable `core-js` features - ES and web standards
import "core-js/stable";
import "regenerator-runtime/runtime";